export default {
  state: {
    guideList: []
  },
  mutations: {
    setFinanceGuildList (state, guideList) {
      state.guideList = guideList
    }
  },
  actions: {
    handleFinanceGuildList ({commit}, guideList) {
      commit('setFinanceGuildList', guideList)
    },
  }
}
